import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'registerType',
})

export class RegisterTypePipe implements PipeTransform {
  private registerType ={'1':'นิติบุคคล','2':'บุคคลธรรมดา'};

  transform(value: any): any {
    try {      
        return this.registerType[value];      
    } catch (error) {
      throw new Error(error.message);
    }
  }
}
